function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
var isRequestError = function isRequestError(err) {
    var _err$response;
    return _typeof(err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data) === 'object' && 'message' in err.response.data && 'code' in err.response.data;
};
export var isAxiosRequestError = function isAxiosRequestError(err) {
    return (err === null || err === void 0 ? void 0 : err.isAxiosError) === true && isRequestError(err);
};
